// Firebase collection names
export const PROJECT_COLLECTION = 'projects';
export const VERSION_COLLECTION = 'projects.versions';
